import React from 'react';
import Tetris from './Tetris';

const TetrisWindow = () => {
    return <Tetris />;
};

export default TetrisWindow;